import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import ModalTerms from "../components/ModalTerms";

const FaqTextAnimation = React.lazy(() => import("./FaqTitle"));

function Faq() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showModal && <ModalTerms toggleModalTerms={() => setShowModal(false)} />}
      <section id="faq" className="faq-section">
        <div class="faq">
          <div className="logo-block">
            <FaqTextAnimation />
          </div>
          <div className="faq-block">
            <div className="faq-scroll">
              <Accordion>
                <Accordion.Item eventKey="0" className="questions">
                  <Accordion.Header className="btn-wrap">
                    What is Mocaverse?
                    <span className="arrow"></span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="answers">
                      <p>
                        Mocaverse is the membership NFT collection for Animoca
                        Brands’ extraordinary family of companies, projects,
                        investments, shareholders, and partners.{" "}
                      </p>
                      <p>
                        This collection will represent our values surrounding
                        Web3 and digital property rights, as well as our
                        one-of-a-kind ecosystem.{" "}
                      </p>
                      <p>
                        We wish to express our deepest appreciation for the
                        immense support of our friends and family by inviting
                        them to this exclusive membership experience. We simply
                        would not be where we are without them.{" "}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1" className="questions">
                  <Accordion.Header className="btn-wrap">
                    Who are the Mocas?
                    <span className="arrow"></span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="answers">
                      <p>
                        The Mocas are a lively community of beings that live in
                        the Mocaverse. There are 5 Moca tribes: Dreamers,
                        Builders, Angels, Connectors, and Neo-Capitalists.{" "}
                      </p>
                      <p>
                        While the Mocas may have their own special abilities,
                        they are most empowered when they work together. The
                        real magic happens when everyone unites for a greater
                        purpose.{" "}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2" className="questions">
                  <Accordion.Header className="btn-wrap">
                    What are the utilities of Mocaverse?
                    <span className="arrow"></span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="answers">
                      <p>
                        Holders will be able to Learn, Play, Do Good, and Build
                        together. Utilities will be co-created by our
                        communities, enjoyed by our communities, and powered by
                        Animoca Brands.{" "}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3" className="questions">
                  <Accordion.Header className="btn-wrap">
                    Who is eligible to mint?
                    <span className="arrow"></span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="answers">
                      <p>
                        Mocaverse NFTs are reserved exclusively for friends and
                        family of Animoca Brands, including the following
                        eligible parties:
                      </p>
                      <ol>
                        <li>
                          Animoca Brands’ institutional and retail investors
                        </li>
                        <li>
                          Employees of Animoca Brands and its subsidiaries
                        </li>
                        <li>
                          Management teams of companies in Animoca Brands’ Web3
                          investment portfolio
                        </li>
                        <li>Partners of Animoca Brands</li>
                        <li>Mocalist members</li>
                      </ol>
                      <p>
                        All eligible parties will receive a free mint quota and
                        a paid mint quota. Parties in categories 1-4 should
                        already have received an email to submit their wallet
                        address for the minting event. Learn more about category
                        5 eligibility in our{" "}
                        <a
                          target="_blank"
                          href="https://medium.com/mocaverse/mocaverse-announces-full-eligibility-criteria-and-mocalist-registration-event-27fcbcdb77"
                          title="Medium article"
                          rel="noreferrer"
                        >
                          Medium article
                        </a>
                        .
                      </p>
                      <p>
                        If you are an eligible party but have not received an
                        email, please contact{" "}
                        <a href="mailto:mocaverse@animocabrands.com">
                          mocaverse@animocabrands.com
                        </a>
                        .
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4" className="questions">
                  <Accordion.Header className="btn-wrap">
                    When is the mint date, and what is the collection size and
                    mint price?
                    <span className="arrow"></span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="answers">
                      <p>
                        Mocaverse will be released in Q1 of 2023! Mocaverse
                        comprises 8,888 NFTs of characters called Mocas, each
                        belonging to a tribe. Eligible parties will receive a
                        free mint quota and a paid mint quota. We are excited to
                        share more details soon. Stay tuned!{" "}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5" className="questions">
                  <Accordion.Header className="btn-wrap">
                    What tokens will be accepted for payment?
                    <span className="arrow"></span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="answers">
                      <p>
                        Eligible parties may mint their NFTs using the following
                        tokens on Ethereum Mainnet (ERC-20):{" "}
                      </p>
                      <ul>
                        <li>$ETH</li>
                        <li>$USDC</li>
                        <li>$APE</li>
                        <li>$SAND</li>
                        <li>$ASTRAFER</li>
                        <li>$BONDLY</li>
                        <li>$GMEE</li>
                        <li>$REVV</li>
                        <li>$TOWER</li>
                        <li>$PRIMATE</li>
                        <li>$LYM</li>
                        <li>$DOSE</li>
                        <li>$PROS</li>
                        <li>$QUIDD</li>
                      </ul>
                      <p>
                        Kindly ensure there will also be sufficient ETH in the
                        wallet for gas fees.{" "}
                      </p>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </div>
        </div>
        <p className="legal">
          <AnimocaBrandIcon />
          <div onClick={() => setShowModal(true)} className="link">
            Terms of Use
          </div>
        </p>
      </section>
    </>
  );
}

export default Faq;

const AnimocaBrandIcon = () => {
  return (
    <svg
      version="1.1"
      id="Shape_3_copy_1_"
      x="0px"
      y="0px"
      width="999.874px"
      height="603.925px"
      viewBox="0 0 999.874 603.925"
      enable-background="new 0 0 999.874 603.925"
      className="animoca"
    >
      <g id="Shape_3_copy">
        <g>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            fill="#FFFFFF"
            d="M403.52,323.438l41.261-3.405l-20.82-55.232L403.52,323.438z
M537.242,230.507c1.351,1.271,2.731,2.945,4.145,5.024c1.413,2.081,2.874,4.25,4.381,6.51l53.791,76.893v-82.083
c0-5.333,1.146-9.429,3.438-12.287c0.061-0.074,0.128-0.139,0.189-0.212l-66.29,5.86
C537.01,230.313,537.131,230.403,537.242,230.507z M536.896,230.212c-0.074-0.064-0.12-0.105-0.155-0.136
C536.805,230.133,536.896,230.212,536.896,230.212z M372.021,222.526l14.622-1.323c4.63-0.42,7.746-3.708,7.746-8.172V133.29
c0-3.733,1.473-7.342,4.279-10.598c2.82-3.091,6.321-4.841,10.414-5.212l19.661-1.779c3.938-0.356,7.318,0.801,10.153,3.562
c2.846,2.61,4.275,5.85,4.275,9.612v79.74c0,4.465,3.125,7.188,7.756,6.769l14.868-1.346c0.736-0.067,1.449-0.298,2.123-0.655
c4.431-2.364,5.367-5.373,5.367-7.493v-79.741c0-3.748,1.471-7.356,4.284-10.599c2.82-3.092,6.321-4.841,10.41-5.211l19.655-1.779
c3.976-0.36,7.386,0.796,10.413,3.539c2.847,2.61,4.281,5.849,4.281,9.611v79.741c0,4.464,3.118,7.188,7.749,6.769l14.612-1.322
c4.63-0.42,7.746-3.708,7.746-8.172v-79.741c0-11.873-4.536-21.247-13.416-27.822c-8.591-6.616-19.158-9.394-31.386-8.287
l-19.655,1.779c-11.589,1.049-21.565,5.215-29.748,12.402c-8.145-5.709-18.046-8.076-29.487-7.04l-19.661,1.78
c-12.119,1.096-22.742,5.776-31.637,13.991c-8.609,8.159-13.164,18.614-13.164,30.228v79.741
C364.28,220.222,367.392,222.945,372.021,222.526z M766.383,175.716c8.579,6.585,19.133,9.379,31.376,8.271
c16.958-1.535,29.803-4.345,39.346-8.579c3.3-1.502,5.199-4.276,5.199-7.617v-9.632c0.01-6.299-5.244-7.773-8.962-6.505
c-8.995,2.977-20.625,5.08-35.583,6.433c-4.088,0.37-7.59-0.742-10.413-3.341c-2.833-2.612-4.275-5.906-4.275-9.828V98.319
c0-3.904,1.442-7.476,4.271-10.583c2.838-3.108,6.339-4.858,10.418-5.227c14.939-1.352,26.902-1.353,35.526-0.014
c4.245,0.681,9.019-1.87,9.019-8.119v-9.635c0-3.167-1.696-5.562-4.982-6.699c-9.479-2.51-22.424-2.983-39.563-1.431
c-12.232,1.107-22.881,5.896-31.633,14.22c-8.608,8.155-13.164,18.616-13.164,30.213v46.599
C752.962,159.431,757.473,168.865,766.383,175.716z M954.18,53.579c-8.596-6.615-19.157-9.393-31.387-8.287
c-15.315,1.386-26.854,3.392-34.48,6.033c-5.441,2.077-6.027,6.14-6.027,7.786v10.074c0,1.954,0.518,3.565,1.525,4.787
c1.291,1.547,3.22,2.285,5.438,2.084c0.367-0.033,1.258-0.19,1.618-0.298c5.908-1.8,16.65-3.399,31.927-4.782
c3.938-0.356,7.323,0.802,10.158,3.562c2.851,2.609,4.281,5.849,4.281,9.611v6.663l-34.095,3.086
c-12.253,1.109-22.89,5.883-31.642,14.206c-8.729,8.292-13.159,18.383-13.159,29.999c0,11.77,4.513,21.213,13.416,28.075
c8.587,6.583,19.143,9.376,31.385,8.269l56.711-5.133c4.412-0.399,7.495-3.758,7.495-8.149V81.423
C967.344,69.826,962.789,60.191,954.18,53.579z M937.232,145.46l-34.095,3.086c-4.089,0.37-7.587-0.743-10.409-3.342
c-2.844-2.611-4.284-5.904-4.284-9.827c0-3.765,1.44-7.266,4.284-10.371c2.822-3.092,6.32-4.842,10.409-5.212l34.095-3.087V145.46
z M702.524,236.826l-18.465,1.523v93.664l21.196-1.749c4.646-0.384,8.29-0.81,10.928-1.278c2.637-0.469,5.369-1.322,8.195-2.56
c2.826-1.236,5.275-2.85,7.349-4.842c9.357-8.68,14.036-22.683,14.036-42.012c0-13.617-2.059-23.646-6.17-30.084
c-4.115-6.438-9.186-10.333-15.215-11.688C718.351,236.447,711.063,236.121,702.524,236.826z M309.486,79.897l24.452-2.214
c4.631-0.42,7.746-3.704,7.746-8.171V58.308c0-3.596-2.399-7.007-7.746-6.522l-24.452,2.213c-5.347,0.484-7.74,4.329-7.74,7.925
v11.204C301.746,77.596,304.856,80.316,309.486,79.897z M567.454,87.038c1.738-0.952,3.175-2.249,4.334-3.721l29.574,30.456
l-17.639,5.965c-0.562-1.71-1.574-3.25-3.065-4.397c-4.364-3.358-10.921-2.288-14.681,2.399
c-3.748,4.686-3.268,11.207,1.09,14.567c4.351,3.355,10.929,2.271,14.668-2.411c1.034-1.283,1.717-2.701,2.109-4.169l17.698,8.238
c-0.002,0.351-0.053,0.694-0.053,1.044c0,37.863,30.715,65.779,68.604,62.349c37.893-3.43,68.612-36.907,68.612-74.77
c0-37.863-30.72-65.776-68.612-62.346c-14.2,1.286-27.397,6.794-38.34,15.175l-14.947-10.35c1.103-1.725,1.816-3.708,1.921-5.828
c0.292-6.123-4.421-10.892-10.539-10.647c-6.101,0.268-11.296,5.455-11.594,11.591c-0.288,6.122,4.423,10.891,10.533,10.624
c1.669-0.064,3.257-0.528,4.713-1.254l3.268,20.508l-40.417-13.71c0.268-2.25-0.03-4.544-1.027-6.627
c-2.915-6.077-10.423-8.177-16.77-4.697c-6.343,3.48-9.123,11.24-6.205,17.316C553.596,88.42,561.122,90.528,567.454,87.038z
M685.323,152.166c5.031-0.455,9.093,3.264,9.093,8.268c0,5.025-4.062,9.465-9.093,9.921c-5.031,0.455-9.095-3.25-9.095-8.274
C676.229,157.076,680.292,152.622,685.323,152.166z M653.681,155.031c5.035-0.456,9.104,3.262,9.104,8.266
c0,5.024-4.068,9.465-9.104,9.921c-5.03,0.456-9.093-3.25-9.093-8.273C644.588,159.94,648.65,155.485,653.681,155.031z
M723.31,213.703c-0.234-0.008-0.337-0.012-0.369-0.013C722.992,213.692,723.16,213.698,723.31,213.703z M666.849,218.296
c-0.559,0.175-1.101,0.361-1.614,0.569l1.614-0.143V218.296z M723.539,213.71c-0.066-0.002-0.099-0.003-0.153-0.005
C723.471,213.708,723.539,213.71,723.539,213.71z M900.543,311.051c-0.057,0.137-0.12,0.288-0.19,0.456
C900.392,311.414,900.462,311.244,900.543,311.051z M878.309,334.904c-8.29,4.45-18.119,7.144-29.485,8.081
c-13.629,1.125-24.87-0.521-33.726-4.936c-6.28-3.185-11.384-7.705-15.309-13.563s-5.887-11.705-5.887-17.541
c0-3.39,1.178-6.388,3.531-8.999c2.355-2.61,5.354-4.066,8.997-4.367c2.952-0.243,5.448,0.492,7.489,2.206
c2.04,1.715,3.783,4.364,5.229,7.946c1.756,4.249,3.657,7.764,5.698,10.544c2.041,2.783,4.913,4.977,8.62,6.584
c3.704,1.609,8.572,2.164,14.602,1.667c8.29-0.685,15.025-3.17,20.206-7.457c5.183-4.287,7.772-9.316,7.772-15.091
c0-4.579-1.397-8.182-4.191-10.808c-2.796-2.625-6.406-4.508-10.834-5.648c-4.428-1.141-10.348-2.253-17.757-3.336
c-9.925-1.501-18.229-3.532-24.918-6.086c-6.688-2.555-11.996-6.353-15.92-11.395c-3.927-5.042-5.889-11.546-5.889-19.517
c0-7.593,2.072-14.51,6.219-20.751c4.144-6.24,10.141-11.27,17.992-15.087c2.199-1.069,4.519-2.01,6.935-2.848l-104.146,9.208
c3.813,0.124,7.335,0.46,10.544,1.026c6.782,1.198,12.937,3.985,18.463,8.361c14.381,11.114,21.572,29.222,21.572,54.323
c0,8.283-0.723,15.906-2.166,22.864c-1.445,6.96-3.674,13.31-6.688,19.049c-3.016,5.74-6.878,10.97-11.588,15.688
c-3.707,3.634-7.757,6.634-12.152,9.005c-4.397,2.372-9.123,4.174-14.179,5.405c-5.056,1.233-10.755,2.111-17.097,2.635
l-36.458,3.009c-5.087,0.42-8.919-0.032-11.492-1.358c-2.576-1.324-4.256-3.352-5.041-6.079
c-0.786-2.727-1.178-6.319-1.178-10.775V235.669c0-6.025,1.351-10.497,4.052-13.418c1.308-1.415,3.015-2.539,5.103-3.385
l-43.74,3.868c0.097,0.096,0.202,0.18,0.297,0.28c2.322,2.477,3.484,6.381,3.484,11.714v108.536
c0,12.112-5.024,18.582-15.072,19.411c-2.512,0.208-4.773,0.032-6.782-0.522c-2.011-0.557-3.895-1.546-5.652-2.97
c-1.76-1.423-3.392-3.123-4.898-5.103c-1.508-1.978-3.015-4.002-4.522-6.075l-52.472-76.06v80.861
c0,5.271-1.225,9.358-3.674,12.257c-2.449,2.9-5.591,4.51-9.42,4.826c-3.957,0.326-7.13-0.777-9.515-3.311
c-2.388-2.533-3.58-6.402-3.58-11.611V248.501c0-4.518,0.502-8.104,1.507-10.762c0.856-2.098,2.125-3.958,3.791-5.59
l-77.511,6.854c1.034,0.854,1.948,1.82,2.738,2.899c1.602,2.19,2.951,4.574,4.05,7.149c1.099,2.578,2.497,6.023,4.192,10.339
l36.081,86.072c2.827,6.545,4.24,11.354,4.24,14.43c0,3.2-1.336,6.244-4.004,9.132c-2.669,2.886-5.887,4.486-9.656,4.797
c-2.199,0.182-4.083-0.056-5.651-0.71c-1.571-0.656-2.889-1.611-3.957-2.874c-1.069-1.261-2.214-3.237-3.439-5.93
c-1.225-2.689-2.277-5.067-3.156-7.129l-6.594-16.775l-56.145,4.632l-6.595,18.242c-2.576,7.116-4.774,11.957-6.594,14.522
c-1.823,2.564-4.805,4.021-8.95,4.362c-3.518,0.29-6.626-0.74-9.326-3.09c-2.701-2.35-4.05-5.157-4.05-8.42
c0-1.883,0.313-3.854,0.941-5.915c0.627-2.059,1.664-4.938,3.109-8.633l35.327-92.531c1.003-2.655,2.213-5.845,3.626-9.571
c1.414-3.724,2.92-6.845,4.522-9.363c0.754-1.185,1.624-2.274,2.6-3.276l-90.629,8.014c0.769,0.225,1.524,0.467,2.256,0.74
c4.333,1.463,8.163,3.75,11.493,6.864c3.328,3.114,5.855,6.845,7.583,11.188c1.727,4.345,2.591,9.027,2.591,14.047
c0,10.292-2.906,18.753-8.715,25.383c-5.81,6.63-14.617,11.717-26.423,15.265c4.96,2.226,9.703,5.727,14.225,10.498
c4.522,4.773,8.556,9.916,12.105,15.427c3.547,5.514,6.312,10.526,8.29,15.037c1.979,4.513,2.967,7.648,2.967,9.403
c0,1.821-0.581,3.673-1.743,5.558c-1.163,1.884-2.748,3.427-4.757,4.628c-2.011,1.201-4.333,1.911-6.971,2.129
c-3.141,0.259-5.78-0.262-7.913-1.56c-2.137-1.298-3.973-3.015-5.511-5.146c-1.54-2.132-3.627-5.286-6.265-9.461l-11.21-17.714
c-4.02-6.508-7.615-11.42-10.786-14.735c-3.172-3.316-6.392-5.497-9.656-6.546c-3.266-1.049-7.381-1.368-12.341-0.959
l-9.797,0.809v44.337c0,5.836-1.288,10.242-3.862,13.215c-2.576,2.974-5.935,4.632-10.08,4.974
c-4.46,0.368-7.913-0.791-10.363-3.476c-2.449-2.683-3.673-6.818-3.673-12.404V270.695c0-6.025,1.349-10.497,4.05-13.419
c0.153-0.165,0.331-0.313,0.494-0.471l-55.291,4.889c1.327,0.479,2.608,1.029,3.833,1.67c3.265,1.676,6.154,3.902,8.667,6.674
c2.511,2.775,4.427,5.912,5.746,9.41c1.319,3.5,1.979,7.259,1.979,11.274c0,13.807-6.91,24.48-20.725,32.021
c18.149,4.276,27.225,14.761,27.225,31.453c0,7.719-1.979,14.833-5.935,21.34c-3.957,6.509-9.295,11.515-16.014,15.018
c-4.208,2.105-9.044,3.744-14.508,4.915c-5.464,1.174-11.839,2.06-19.124,2.661l-42.204,3.482
c-6.093,0.503-10.442-0.503-13.047-3.019c-0.251-0.242-0.487-0.506-0.714-0.781v5.465c0,0,0.522,1.007,1.538,1.273
c34.613,9.067,641.878,168.158,641.878,168.158L900.32,319.354v-7.769c-0.875,2.098-1.902,4.146-3.123,6.135
C892.895,324.729,886.599,330.455,878.309,334.904z M180.85,261.694c-0.059-0.021-0.09-0.032-0.136-0.049
C180.79,261.672,180.85,261.694,180.85,261.694z M329.152,99.032l-14.873,1.347c-5.348,0.484-7.746,4.342-7.746,7.942v112.664
c0,4.464,3.116,7.188,7.746,6.769l14.873-1.346c4.625-0.419,7.74-3.707,7.74-8.172V105.572
C336.892,101.973,334.499,98.547,329.152,99.032z M899,228.646c-1.342,0-1.39,0.956-1.39,0.956
c0.001,0.117,0.011,0.234,0.011,0.352c0,3.327-1.178,6.42-3.533,9.281c-2.355,2.863-5.291,4.438-8.808,4.728
c-3.203,0.264-5.638-0.335-7.301-1.799c-1.665-1.462-3.471-3.933-5.417-7.413c-2.513-5-5.527-8.815-9.044-11.444
c-3.518-2.627-9.17-3.621-16.957-2.978c-7.223,0.597-13.047,2.663-17.475,6.195c-4.428,3.536-6.642,7.53-6.642,11.986
c0,2.762,0.754,5.084,2.262,6.968c1.507,1.885,3.579,3.439,6.217,4.664c2.639,1.228,5.307,2.137,8.008,2.729
c2.699,0.593,7.159,1.418,13.377,2.473c7.786,1.179,14.838,2.604,21.149,4.28c6.312,1.676,11.681,3.9,16.108,6.672
c4.428,2.773,7.881,6.457,10.362,11.053c0.139,0.258,0.26,0.533,0.392,0.798v-48.544C900.32,229.601,900.145,228.646,899,228.646z
M142.536,235.83v-79.741c0-11.597-4.553-21.232-13.168-27.844c-8.596-6.615-19.162-9.393-31.386-8.287
c-15.316,1.386-26.855,3.392-34.487,6.033c-5.438,2.078-6.022,6.14-6.022,7.786v10.074c0,1.954,0.518,3.565,1.52,4.787
c1.292,1.547,3.225,2.285,5.443,2.084c0.365-0.033,1.257-0.19,1.614-0.298c5.917-1.801,16.654-3.399,31.932-4.782
c3.932-0.356,7.322,0.802,10.163,3.562c2.84,2.61,4.274,5.849,4.274,9.611v6.664l-34.092,3.085
c-12.248,1.109-22.89,5.883-31.637,14.204c-8.739,8.294-13.17,18.385-13.17,30c0,11.77,4.517,21.222,13.425,28.074
c8.582,6.584,19.139,9.377,31.382,8.269l56.711-5.133C139.454,243.579,142.536,240.22,142.536,235.83z M112.418,220.126
l-34.092,3.086c-4.089,0.37-7.594-0.742-10.409-3.342c-2.85-2.61-4.284-5.905-4.284-9.827c0-3.765,1.434-7.266,4.284-10.371
c2.815-3.091,6.32-4.842,10.409-5.212l34.092-3.086V220.126z M259.575,310.181l25.058-2.066c6.72-0.555,12.373-1.601,16.957-3.142
c4.584-1.539,8.086-3.804,10.504-6.797c2.417-2.991,3.626-6.936,3.626-11.831c0-3.827-0.975-7.121-2.92-9.879
c-1.947-2.757-4.648-4.714-8.102-5.873c-3.266-1.11-9.703-1.271-19.312-0.478l-25.812,2.129V310.181z M177.902,240.099
l14.622-1.324c4.629-0.419,7.736-3.706,7.736-8.171v-79.741c0-3.732,1.471-7.341,4.284-10.6c2.82-3.09,6.32-4.84,10.409-5.21
l19.666-1.78c3.937-0.356,7.313,0.803,10.153,3.562c2.844,2.61,4.279,5.849,4.279,9.611v79.741c0,4.464,3.115,7.188,7.745,6.77
l14.879-1.348c4.407-0.398,7.49-3.758,7.49-8.148V143.72c0-11.872-4.54-21.245-13.417-27.821
c-8.59-6.616-19.062-9.402-31.129-8.31l-19.666,1.78c-12.109,1.097-22.738,5.777-31.632,13.992
c-8.61,8.159-13.165,18.614-13.165,30.228v79.741C170.157,237.793,173.272,240.518,177.902,240.099z M171.871,339.916
c-4.898-2.733-12.216-3.699-21.949-2.896l-29.109,2.402v40.288l30.051-2.479c18.903-1.56,28.356-9.148,28.356-22.767
C179.219,347.499,176.77,342.65,171.871,339.916z M120.812,319.371l25.624-2.113c6.971-0.575,12.355-1.679,16.156-3.311
c3.799-1.631,6.704-4.38,8.714-8.249c1.569-2.766,2.355-5.78,2.355-9.043c0-6.966-2.482-11.388-7.442-13.271
c-4.961-1.881-12.529-2.402-22.703-1.563l-22.703,1.873V319.371z"
          />
        </g>
      </g>
    </svg>
  );
};
